import KAMPYLE_DATA from "../modules/KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "../modules/KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_UTILS from "../modules/KAMPYLE_UTILS";
import KAMPYLE_CONSTANT from "../modules/KAMPYLE_CONSTANT";

  var behaviouralListenerPrefix = 'decibel.ks.realtime.behaviours.';
  var scoreListenerPrefix = 'decibel.ks.realtime.';

  function init() {
    KAMPYLE_EVENT_DISPATCHER.subscribe('neb_showForm', triggerDecibelEvent);
    document.addEventListener('decibel.ks.realtime', setData);
  }

  function triggerDecibelEvent(eventName, data) {
    var formId = data.formId;
    var formData = KAMPYLE_DATA.getFormData(formId);
    var decibelBehavioural = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelBehavioural');
    var decibelScore = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelScore');

    if (decibelBehavioural || decibelScore) {
      if (typeof window.decibelInsight === 'function') {
        window.decibelInsight('sendTrackedEvent', 'Medallia Digital: Real-time activated survey', formId);
      }
    }
  }

  function setData(e) {
    var decibelData = KAMPYLE_UTILS.getNestedPropertyValue(e, 'detail.data');
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DECIBEL_DATA, decibelData);
  }

  function listenToBehaviouralEvent(eventName, delay, callback, formId) {
    var event = behaviouralListenerPrefix + eventName;

    var onBehaviouralEventUpdate = function (e) {
      document.removeEventListener(event, onBehaviouralEventUpdate);
      KAMPYLE_DATA.deleteMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DOM_EVENT_HANDLERS + '.' + 'decibelBehavioural');

      var timeoutRef = setTimeout(function () {
        KAMPYLE_DATA.setMemoryData('targetingState.decibelBehavioural', true);

        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
          formId: formId,
          targetingRule: 'decibelBehavioural',
          formTriggerType: KAMPYLE_DATA.getFormTriggerType(formId),
          targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
          isPassed: true,
          expected: "decibelBehavioural rule should have been triggered: " + eventName,
          actual: true,
        });

        callback();
      }, (delay || 0) * 1000);

      KAMPYLE_DATA.setTimeoutHandler('decibelBehavioural', timeoutRef);
    };

    document.addEventListener(event, onBehaviouralEventUpdate);
    KAMPYLE_DATA.setDOMEventHandler('decibelBehavioural', event, onBehaviouralEventUpdate);
  }

  function listenToScoreEvent(eventName, score, condition, callback, formId) {
    var event = scoreListenerPrefix + eventName;

    var onScoreEventUpdate = function (e) {
      var isRuleMet = isScoreValid(e.detail, condition, score);
      if (isRuleMet) {
        KAMPYLE_DATA.setMemoryData('targetingState.decibelScore', true);

        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_TARGETING_RULE_EVALUATED,{
          formId: formId,
          targetingRule: 'decibelScore',
          formTriggerType: KAMPYLE_DATA.getFormTriggerType(formId),
          targetingPhase: KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING,
          isPassed: isRuleMet,
          expected: "Decibel score should be " + condition + " " + score,
          actual: "Decibel current score: " + e.detail +", Expected score: " + score + ", Event name:" + eventName,
        });

        document.removeEventListener(event, onScoreEventUpdate);
        KAMPYLE_DATA.deleteMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DOM_EVENT_HANDLERS + '.' + 'decibelBehavioural');

        callback();
      }
    }

    document.addEventListener(event, onScoreEventUpdate);
    KAMPYLE_DATA.setDOMEventHandler('decibelBehavioural', event, onScoreEventUpdate);
  }

  function isScoreValid(currentScore, condition, expectedScore) {
    var scoreAsNumber = Number(expectedScore);
    switch (condition) {
      case 'smallerThan':
        return currentScore < scoreAsNumber;

      case 'equals':
        return currentScore === scoreAsNumber;

      case 'greaterThan':
        return currentScore > scoreAsNumber;
      default:
        return false;
    }
  }

  export default {
    init: init,
    listenToBehaviouralEvent: listenToBehaviouralEvent,
    listenToScoreEvent: listenToScoreEvent,

    // for testing
    isScoreValid: isScoreValid,
  }